// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TooltipContent_wrapper__s0n1j","outage":"TooltipContent_outage__1XF81","icon":"TooltipContent_icon__z2wAV"};